import React from 'react';

export default class Page8 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">

                                <div className="ilead-rgt">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="border_subtitle"> Managing risk aversion</div>
                                            <p>Our brains have developed over time to make quick decisions
                                                based on limited data. The same evolutionary process has
                                                equipped us to be more vigilant of risk and threat than we
                                                are open to opportunity. Put these together and it is all
                                                too easy to arrive at a default position based on caution
                                                rather than innovation; a position that drives 'yes...but'
                                                thinking with the risk of closing
                                                down possibilities too early, rather than exploring and
                                                expanding on what might be.</p><p>What else can we do to
                                            avoid defaulting to the fastest option, the habitual option or
                                            the most risk free option? </p>
                                            <div className="lightgreencontentbg keyquestionpad">
                                                <ul className="greenbullet-list">
                                                    <li>Challenge the tendency to make quick decisions based
                                                        on tried and tested methods and categorisations.
                                                    </li>
                                                    <li>Seek and be open minded to fresh data/stimulus to
                                                        help you think differently about issues you are
                                                        presented with. Take a mental pause whenever you
                                                        hear yourself saying 'yes...but'.
                                                    </li>
                                                    <li>Actively engage with the process of seeking new
                                                        insights and challenging your existing thoughts as
                                                        this will not happen by chance.
                                                    </li>
                                                </ul>
                                            </div>
                                            <p>Innovation has to be nurtured; the weeds of inertia take over
                                                the garden all too easily! </p>
                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page7')}
                                                    className="button-next-previous-done thought">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div onClick={this.props.handleChangePage('Page9')}
                                                     className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                    </div>
                </div>
            </div>
        </div>;
    }
}